import { intl } from "LocaleWrapper";
import ShipPositionPopover from "view/ships/components/popover/ShipPositionPopover";
import { ShipType } from "view/customerUpdate/CustomerUpdateOverview";
import { Box, Typography } from "@mui/material";

type CustomerUpdateShipLocationChangerProps = {
	ship: ShipType;
	location?: string;
	onEdit: () => void;
}

const CustomerUpdateShipLocationChanger = ({ ship, location, onEdit }: CustomerUpdateShipLocationChangerProps) => {
	const isMultiline = location != null && location.includes(",");

	const text = location
		? location.split(",").map(x => x.trim()).join("\n")
		: intl.formatMessage({ id: "UNKNOWN_LOCATION" });

	return (
		<Box sx={{
			display: "flex",
			alignItems: isMultiline ? "baseline" : "center",
			gap: 1,
			justifyContent: "space-evenly",
		}}>
			<ShipPositionPopover
				//@ts-ignore
				ship={ship} />

			<Typography component="span" className="editable" onClick={onEdit}>{text}</Typography>
		</Box>
	);
};

export default CustomerUpdateShipLocationChanger;
